/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { DataProviderService } from './data-provider.service';
import { QuestionnaireSharedService } from './questionnaire-shared.service';

@Injectable({
  providedIn: 'root',
})
export class QuestionSaveService {
  constructor(
    private dataService: DataProviderService,
    private questionnaireSharedService: QuestionnaireSharedService
  ) {}

  saveAnswer(
    question: any,
    signature: string,
    functionVal: string,
    undersigned: string,
    parentObject: string,
    id: number,
    questionAnswer: string
  ) {
    if (question.questionAnswers === 'signature') {
      this.dataService
        .postAnswer(parentObject, question.answerId, {
          Id: id,
          ParentObject: parentObject,
          QuestionId: question.questionId,
          Answers: question.questionAnswers,
          Answer: JSON.stringify({
            Signature: signature,
            Function: functionVal,
            Undersigned: undersigned,
          }),
        })
        .then((result) => {});
    } else {
      this.dataService
        .postAnswer(parentObject, question.answerId, {
          Id: id,
          ParentObject: parentObject,
          QuestionId: question.questionId,
          Answer: questionAnswer,
        })
        .then((result) => {});
    }
    let answersArray: any = null;
    try {
      answersArray = JSON.parse(questionAnswer);
    } catch (e) {}
    const answerObject = {
      answer: questionAnswer,
      answersArray,
      answerId: question.answerId,
      id,
      parentObject,
      questionId: question.questionId,
    };

    this.questionnaireSharedService.onAnswerChangeEvent.emit(answerObject);
  }
}
